import type { QuestionChoice } from '@/types';
import { useState, useEffect } from 'react';
import Control from '@/components/control';
import DropdownInput from '@/components/dropdown';
import { useContext } from '@/components/slider-type/context';
import Converter from '@/utils/converter';
import { useAppDispatch, useAppSelector } from '@/redux/store';
import { ConfigSlice } from '@/redux/config';
import { selectAnswersDirectByKey, SliderSlice } from '@/redux/slider';
import { GeneralSlice } from '@/redux/general';
import '@/components/slider-type/components/dropdown/dropdown-v1.css';
import '@/components/slider-type/components/dropdown/dropdown-v2.css';

export default function Dropdown() {
  const {
    slide: {
      key,
      multiple = false,
      isSearchHidden = true,
      noResult = '',
      label = '',
      placeholder = '',
      closeButton = 'Auswahl übernehmen',
      choices = [],
    },
  } = useContext();
  const [value, setValue] = useState<QuestionChoice[]>([]);
  const cssVersion = useAppSelector(ConfigSlice.selectors.cssVersion);
  const answersDirect = useAppSelector(selectAnswersDirectByKey(key));
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (answersDirect) {
      const choicesMapped = choices
        .filter((choice) => Converter.Answer.FromMultipleToArray(answersDirect).includes(choice.value))
        .map((choice) => ({
          value: choice.value,
          label: choice.label,
        }));
      setValue(choicesMapped);
    }
  }, [answersDirect]);

  const onChange = (choices: QuestionChoice[]): void => {
    setValue(choices);
    dispatch(
      SliderSlice.actions.setAnswersDefaultByKey({
        key,
        value: Converter.Answer.FromArrayToMultiple(choices.map((v) => v.value)),
      }),
    );
  };

  return (
    <div data-css-version={cssVersion} className='slider-type-dropdown'>
      {cssVersion === 1 ? (
        <DropdownInput
          choices={choices}
          value={value}
          placeholder={placeholder}
          noResult={noResult}
          isSearchHidden={isSearchHidden}
          multiple={multiple}
          closeButton={closeButton}
          onChange={onChange}
          onOpen={(height) => dispatch(GeneralSlice.actions.setExtendedSliderHeight(height))}
          onClose={() => dispatch(GeneralSlice.actions.setExtendedSliderHeight(0))}
        />
      ) : (
        <Control.Dropdown
          choices={choices}
          value={value}
          label={label}
          placeholder={placeholder}
          noResult={noResult}
          isSearchHidden={isSearchHidden}
          multiple={multiple}
          closeButton={closeButton}
          onChange={onChange}
          onOpen={(height) => dispatch(GeneralSlice.actions.setExtendedSliderHeight(height))}
          onClose={() => dispatch(GeneralSlice.actions.setExtendedSliderHeight(0))}
        />
      )}
    </div>
  );
}
